import React from 'react';

import {Anchor, Banner, Icon, Text} from '@albert-io/atomic';

// Adaptive subjects landing (same target as the legacy AdaptiveBanner).
const ADAPTIVE_SUBJECTS_URL = '/subjects/adaptive-practice';

export const AdaptiveSubjectsCallout = () => (
  <Anchor className='block' noUnderline to={ADAPTIVE_SUBJECTS_URL}>
    <Banner
      border={false}
      cardClassName='cursor-pointer hover:background-special-subtle-hover active:background-special-subtle-pressed'
      type='special'
    >
      <span className='flex grow items-center gap-x2'>
        <Icon color='inherit' icon='sparkles' iconStyle='regular' />
        <Text className='grow' color='inherit'>
          Explore our <strong className='italic'>free</strong> Adaptive subjects in Math, ELA,
          Spanish, and Science!
        </Text>
        <Icon color='inherit' icon='arrow-up-right' iconStyle='regular' />
      </span>
    </Banner>
  </Anchor>
);
